import React, { Component } from 'react';
import $ from 'jquery';
import ReactStars from 'react-stars';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import * as actions from './../../../actions';
import { Panel} from 'react-bootstrap';
import { ShareButtons,generateShareIcon } from 'react-share';
const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

class PDeal extends Component{
  constructor(){
    super();
    this.state={
      open: false,
      shareUrl: '',
      msg:'',
      showModal: false,
      showModalLogin: false,
    };
    this.ShareFunc=this.ShareFunc.bind(this);
  }
  
  ShareFunc(evnt)
  {
    var data1={from: 'desktop_web',type:1,did:evnt};
    var data2=JSON.stringify(data1);
    $.ajax({
          method: 'POST',
          url: baseUrl+'createTinyurl',
          dataType:'json',
          data: {req:data2},
          success: function(data){
           this.setState({
              msg: data.msg,
              shareUrl: data.tinyurl,
            })
          }.bind(this),
          error: function(err){
            // console.log("Error"+err);
          }
    });
    this.setState({
      open: !this.state.open,
    });
    setTimeout(() => {this.setState({open: false}); }, 5000);
  }
  render(){
        var product=this.props.data;
        var shareUrl=this.state.shareUrl;
        var title="Hey! Click here "+ shareUrl +" to check "+product.title + " deal from AquaDeals.";
        var description=shareUrl;
        return(
        // var star_rate = product.over_rate >=1 ? product.over_rate :'' ;  
<div className="col-md-3 col-sm-6"> 
    {product.pid ? 
      <div className="prdt_blk">
          {product.dealcount <= 1 ? <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(product.deal_id)}}>
                  <img src={baseAssets+'images/web_imgs/share.png'} alt="Share" />
            </Link> : <span className="lst_share_btn">&nbsp;</span>}
            <Panel className="share_panel " collapsible expanded={this.state.open}>
                <FacebookShareButton url={shareUrl} quote={title} className="test_share">
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <TwitterShareButton url={shareUrl} quote={title} className="test_share">
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
                <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
                  <GooglePlusIcon  size={32} round />
                </GooglePlusShareButton>
            </Panel>  
          {product.dealcount >= 2 ? 
            <div>
                 {product.ad_guarantee_flag === '1' ? <span className="web_ad_guarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/></span> : ''}
                <Link to={"/web/subdeals/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.dtype+"/"+product.url_brand_name+"/"+product.pid} >
                    {product.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+product.promo_ribbion} alt="ribbon" /></i> : ''}
                    <div>
                       <img alt=" " src={product.image !==null && product.image !=='' ? baseAssets+'images/product_imgs/thumbnails/'+product.image : baseAssets+'icons/web_icons/noImage.png'} />
                    </div>
                    {product.title ? <h3>{product.title} {product.quantity}</h3> : <h3>&nbsp;</h3>}
                    {product.brand_name ? <h4>{product.brand_name}</h4> : <h4>&nbsp;</h4>}
                    {product.dealcount >=2 ? <h4>{product.dealcount} deals available</h4> : <h4>&nbsp;</h4>}
               </Link>    
                    <div className="row stars_view_blk">
                      <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
                        <div className="prdt_str_rt">
                          <ReactStars
                              count={5}
                              className={'webRate_blk_item'}
                              size={17}
                              value={product.over_rate >=1 ? product.over_rate : 0}
                              edit={false}
                              color1={'#ccc'}
                              color2={'#ffc50a'} />
                        </div>
                      </div>
                      <div className="col-md-5 col-xs-5"  style={{paddingLeft:0}}>
                      {product.count > 0 && product.dealcount <= 1 ?  <span className="prdt_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> {product.count}</span> : <span className="prdt_views hide_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> 0</span>}
                      </div>
                    </div>
                    <div className="clr"></div>
            </div> : 
            <div>
                {product.ad_guarantee_flag === 1 ? <img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/> : ''}
                <Link key={product.pid} className='cursor' to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pid+"/"+product.deal_id} >
                    {product.promo_ribbion ? <i className="ribbon_img"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/'+product.promo_ribbion} alt="" /></i> : ''}
                    <div>
                        <img alt=" " src={product.image !==null && product.image !=='' ? 'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/'+product.image : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png'}/>
                    </div>
                    {product.title ? <h3>{product.title} {product.quantity}</h3> : <h3>&nbsp;</h3>}
                    {product.brand_name ? <h4>{product.brand_name}</h4>: <h4>&nbsp;</h4>}
                    {product.pricediff ?  <h4><span>AquaCash Discount</span>&nbsp;<span>&#8377;{product.pricediff}</span></h4> : ''}
                    {product.pricediff ==="" || product.pricediff ===0 ? <h4>MRP &#8377; {product.mrp}</h4> : ''} 
                </Link> 
                <div className="row stars_view_blk">
                      <div className="col-lg-7 col-md-7 col-xs-7" style={{paddingRight:'0'}}>
                        <div className="prdt_str_rt">
                           <ReactStars
                              count={5}
                              className={'webRate_blk_item'}
                              size={17}
                              value={product.over_rate >=1 ? product.over_rate : 0}
                              edit={false}
                              color1={'#ccc'}
                              color2={'#ffc50a'} />
                        </div>
                      </div>
                      <div className="col-lg-5 col-md-5 col-xs-5"  style={{paddingLeft:0}}>
                          {product.count > 0 && product.dealcount <= 1 ?  <span className="prdt_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> {product.count}</span> : <span className="prdt_views hide_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> 0</span>}
                      </div>
                </div>   
                <div className="clr"></div>
            </div>
         }
      </div>   :    
      <div className="prdt_blk">
          {product.ad_guarantee_flag === 1 ? <img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/> : ''}
          {product.dealcount <= 1 ? <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(product.id)}}>
                <img src={'https://aquadeals.in/admin/assets/images/web_imgs/share.png'} alt="Share" />
          </Link> : <span className="lst_share_btn">&nbsp;</span>}
          <Panel className="share_panel" collapsible expanded={this.state.open}>
                <FacebookShareButton url={shareUrl} quote={title} className="test_share">
                    <FacebookIcon size={32} round />
                </FacebookShareButton>
                <TwitterShareButton url={shareUrl} quote={title} className="test_share">
                    <TwitterIcon size={32} round />
                </TwitterShareButton>
                <GooglePlusShareButton url={shareUrl} quote={title} className="test_share">
                    <GooglePlusIcon  size={32} round />
                </GooglePlusShareButton>
          </Panel>
          <Link key={product.pid} to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pro_id+"/"+product.id}>
              {product.promo_ribbion ? <i className="ribbon_img"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/'+product.promo_ribbion} alt="" /></i> : ''}
              <div>
                  <img alt=" " src={product.image !==null && product.image!=='' ?'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/'+product.image : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png'}/>
              </div>
              {product.title ? <h3>{product.title} {product.quantity}</h3> : <h3>&nbsp;</h3>}
              {product.brand_name ? <h4>{product.brand_name}</h4> : <h4>&nbsp;</h4>}
              {product.pricediff ?  <h4><span>AquaCash Discount</span>&nbsp;<span>&#8377;{product.pricediff}</span></h4> : ''}
              {product.pricediff ==="" || product.pricediff === 0 ? <h4>MRP &#8377; {product.mrp}</h4> : ''} 
          </Link>
           <div className="row stars_view_blk">
             <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7" style={{paddingRight:'0'}}>
                <div className="prdt_str_rt">
                  <ReactStars
                    count={5}
                    className={'webRate_blk_item'}
                    size={17}
                    value={product.over_rate >=1 ? product.over_rate : 0}
                    edit={false}
                    color1={'#ccc'}
                    color2={'#ffc50a'} />
                </div>
             </div>
             <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5" style={{paddingLeft:0}}>
                 {product.count > 0 ?  <span className="prdt_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> {product.count}</span>: <span className="prdt_views hide_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> 0</span>}
             </div>
          </div>   
          <div className="clr"></div>
      </div>
    } 
  </div>        
    );
    }
}


function mapStateToProps(state){
  return {
    errorMessage:state.auth.error,
    authenticated:state.auth.authenticated,
    formdata:state.auth.formdata,
    formdata_log:state.auth.formdata_log,
  };
}

export default connect(mapStateToProps,actions)(PDeal);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Feed/modules/pdeals_list.js
 **/